import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const storage = getStorage();

export default function AddParticipationForm({ onAdd, onCancel }) {
    const [form, setForm] = useState({
        name: "",
        achievement: "",
        level: "",
        location: "",
        date_start: "",
        date_end: "",
        isAchievement: false, // ✅ default false
    });

    const [media, setMedia] = useState([]);
    const [error, setError] = useState("");
    const [uploading, setUploading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileUpload = async (e) => {
        setError("");
        setUploading(true);
        const files = Array.from(e.target.files);
        const urls = [];

        for (const file of files) {
            if (file.size > 1024 * 1024) {
                setError("File too large. Max 1MB.");
                continue;
            }

            const fileRef = ref(storage, `media/${uuidv4()}_${file.name}`);
            const snap = await uploadBytes(fileRef, file);
            const url = await getDownloadURL(snap.ref);
            urls.push(url);
        }

        setMedia((prev) => [...prev, ...urls]);
        setUploading(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const { name, achievement, level, location, date_start, date_end } = form;
        if (!name || !date_start || !date_end) return alert("Please fill in all required fields.");

        const participation = {
            name,
            achievement,
            level,
            location,
            date_start: new Date(date_start),
            date_end: new Date(date_end),
            media,
            isAchievement: form.isAchievement, // ✅ simpan checkbox

        };

        onAdd(participation);
        setForm({ name: "", achievement: "", level: "", location: "", date_start: "", date_end: "" });
        setMedia([]);
    };

    return (
        <form className="edit-form" onSubmit={handleSubmit} style={{ marginBottom: 30 }}>
            <h4>Add New Participation</h4>

            <div style={{ display: "flex", alignItems: " center" }}>

                <input
                    style={{ width: "50px" }}
                    type="checkbox"
                    checked={form.isAchievement}
                    onChange={(e) =>
                        setForm((prev) => ({ ...prev, isAchievement: e.target.checked }))
                    }
                    id="isAchievement"
                />
                <label htmlFor="isAchievement" style={{ margin: 0 }}>
                    Is Achievement
                </label>


            </div>
            <input name="name" value={form.name} onChange={handleChange} placeholder="Name" required />
            <input name="achievement" value={form.achievement} onChange={handleChange} placeholder="Achievement" />
            <input name="level" value={form.level} onChange={handleChange} placeholder="Level" />
            <input name="location" value={form.location} onChange={handleChange} placeholder="Location" />
            <label style={{ marginTop: 10 }}>Start Date:</label>
            <input type="date" name="date_start" value={form.date_start} onChange={handleChange} required />
            <label>End Date:</label>
            <input type="date" name="date_end" value={form.date_end} onChange={handleChange} required />




            <label>Upload Images:</label>
            <input type="file" accept="image/*" multiple onChange={handleFileUpload} />
            {error && <p style={{ color: "red" }}>{error}</p>}

            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: 10 }}>
                {media.map((url, i) => (
                    <img key={i} src={url} alt={`Uploaded ${i}`} style={{ width: 120, borderRadius: 6 }} />
                ))}
            </div>

            <div className="participation-buttons" style={{ marginTop: 16 }}>
                <button type="submit" disabled={uploading}>Add</button>
                <button type="button" onClick={onCancel} style={{ marginLeft: 10 }}>Cancel</button>
            </div>
        </form>
    );
}